document.addEventListener("DOMContentLoaded", function () {
    const startCalibrationButton = document.getElementById('startCalibration');
    const backToCalibrationButton = document.getElementById('backToCalibration');
    const circle = document.querySelector('.circle');
    const ringSizeDisplay = document.getElementById('ringSize');
    const mmSizeDisplay = document.getElementById('mmSize');
    const screen1 = document.getElementById('screen1');
    const screen2 = document.getElementById('screen2');
	const sizeSlider = document.getElementById('sizeSlider');
	const calibrationSlider = document.getElementById('calibrationSlider');
    const rectangle = document.querySelector('.rectangle');

    let calibrationFactor = 1;

    const sizes = {
        'A': 37.8, 'A½': 38.33, 'B': 38.96, 'B½': 39.58, 'C': 40.53, 'C½': 41.15, 'D': 41.78,
        'D½': 42.41, 'E': 42.9, 'E½': 43.5, 'F': 44.2, 'F½': 44.8, 'G': 45.5, 'G½': 46.1,
        'H': 46.8, 'H½': 47.4, 'I *Swarovski Size 48': 48.0, 'I½': 48.7, 'J *Swarovski Size 50': 49.3, 'J½': 49.9, 'K': 50.6,
        'K½': 51.2, 'L *Swarovski Size 52': 51.9, 'L½': 52.5, 'M': 53.1, 'M½': 53.8, 'N *Swarovski Size: 55': 54.4, 'N½': 55.1,
        'O': 55.7, 'O½': 56.3, 'P': 57.0, 'P½': 57.6, 'Q *Swarovski Size 58': 58.3, 'Q½': 58.9, 'R *Swarovski Size 60': 59.5,
        'R½': 60.2, 'S': 60.8, 'S½': 61.4, 'T *Swarovski Size 62': 62.1, 'T½': 62.7, 'U': 63.4, 'U½': 64.0,
        'V *Swarovski Size 64': 64.6, 'V½': 65.3, 'W': 65.9, 'W½': 66.6, 'X': 67.2, 'X½': 67.8, 'Y': 68.5,
        'Y½': 69.1, 'Z': 69.7, 'Z½': 70.4
    };

    let currentSizeIndex = Object.keys(sizes).indexOf('O');


	calibrationSlider.addEventListener('input', () => {
        calibrationFactor = calibrationSlider.value;
        rectangle.style.transform = `scale(${calibrationFactor})`;
    });
	
	sizeSlider.addEventListener('input', () => {
        currentSizeIndex = parseInt(sizeSlider.value);
        updateRingSize();
    });

   startCalibrationButton.addEventListener('click', () => {
    screen1.style.display = 'none';
    screen2.style.display = 'block';
    updateRingSize();
     window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
});
});

    backToCalibrationButton.addEventListener('click', () => {
        screen2.style.display = 'none';
        screen1.style.display = 'block';
    });


    function updateRingSize() {
    const sizeKeys = Object.keys(sizes);
    const currentSizeKey = sizeKeys[currentSizeIndex];
    const currentCircumference = sizes[currentSizeKey];
    const diameter = currentCircumference / Math.PI;

    circle.style.width = `${diameter * calibrationFactor}mm`;
    circle.style.height = `${diameter * calibrationFactor}mm`;

    const displayText = currentSizeKey.replace(' *', '<br>');
    ringSizeDisplay.innerHTML = displayText; // Use innerHTML here instead of textContent
    mmSizeDisplay.textContent = currentCircumference.toFixed(2);
}

    // Initialize the slider max value and starting value based on sizes
    sizeSlider.max = Object.keys(sizes).length - 1;
    sizeSlider.value = currentSizeIndex;
});